import React, {
  useContext, useState,
} from 'react';
import {
  Portal,
} from 'react-native-paper';
import { NativeBaseProvider, View } from 'native-base';
import 'setimmediate';
import { useMutation } from '@apollo/client';
import { ImageEditor } from 'expo-dynamic-image-crop';
import { useToast } from 'react-native-toast-notifications';
import { ModalContext } from '../../context/ModalContext';
import { getFileType } from '../../utils/utils';
import { UpdateOneFile } from '../../gql/file/mutation';

function DocumentEditor() {
  const {
    displayDocumentEditorModal,
    toggleDocumentEditorModal,
  } = useContext(ModalContext);

  const toast = useToast();

  const [updateOneFile] = useMutation(UpdateOneFile);

  const [actionIsLoading, setActionIsLoading] = useState(false);

  const base64file = displayDocumentEditorModal.file;
  const fileType = base64file ? getFileType(base64file) : undefined;

  if (!displayDocumentEditorModal.display) return null;

  if (!fileType?.startsWith('image/')) {
    toast.show('Format de fichier non pris en charge');
    toggleDocumentEditorModal();
    return null;
  }

  return (
    <View style={{ flex: 1 }}>
      {base64file && (
      <ImageEditor
        isVisible
        imageUri={base64file}
        onEditingComplete={async (croppedImageData) => {
          setActionIsLoading(true);
          const lBase64file = croppedImageData.uri;
          await updateOneFile({
            variables: {
              file: lBase64file,
              fileId: displayDocumentEditorModal.fileId,
            },
          });
          toggleDocumentEditorModal();
          setActionIsLoading(false);
        }}
        onEditingCancel={toggleDocumentEditorModal}
        fixedAspectRatio={undefined} // Allow free-form cropping
        dynamicCrop
      />
      )}
    </View>
  );
}

export default function DocumentEditorModal() {
  return (
    <Portal>
      <NativeBaseProvider>
        <DocumentEditor />
      </NativeBaseProvider>
    </Portal>
  );
}
